import { object, array, string, date } from 'yup'
import { decimalSchema, daysSchema } from '@/validation_schemas/common'
import { FORM_FIELD_VALUE_TYPES, PERSONALIZATION_RULE_STATUSES } from '@/constants'

export const getValueSchemaForValueType = (label = 'Value') => ([value_type], _schema) => {
  if (!value_type) {
    return string().nullable()
  }

  switch (value_type) {
    case FORM_FIELD_VALUE_TYPES.STRING_LIST:
      return array().of(string()).label(label).required().min(1)
    case FORM_FIELD_VALUE_TYPES.CURRENCY:
      return decimalSchema.label(label).required()
    case FORM_FIELD_VALUE_TYPES.DAYS:
      return daysSchema.label(label).required()
    default:
      return string().label(label).required()
  }
}

export const valueSchema = string().when('$value_type', getValueSchemaForValueType())

export const valueTypeSchema = string()
  .oneOf(Object.values(FORM_FIELD_VALUE_TYPES))
  .label('Value type')
  .nullable()

export const personalizationRuleOperatorSchema = object({
  name: string().label('Operator name').required(),
  sdr_operator: string().label('SDR operator').required(),
  sdr_function_name: string().label('SDR function name').nullable(),
}).label('Operator').required()

export const personalizationRuleConditionSchema = object({
  name: string().label('Condition name').required(),
  sdr_expression_field_path: string().label('SDR expression field path').required(),
  operator: personalizationRuleOperatorSchema,
  values: array().of(valueSchema).required().label('Condition values'),
  value_type: valueTypeSchema
})

export const personalizationRuleActionSchema = object({
  name: string().label('Action name').required(),
  settings_fields_paths: array().of(string()).label('Settings fields paths').required(),
  value: valueSchema,
  value_type: valueTypeSchema
})

export const personalizationRuleSchema = object({
  name: string().label('Rule name').required(),
  status: string().label('Rule status').required().oneOf(PERSONALIZATION_RULE_STATUSES),
  conditions: array().of(personalizationRuleConditionSchema).required().min(1).label('Conditions'),
  actions: array().of(personalizationRuleActionSchema).required().min(1).label('Actions'),
  published_at: date().label('Published at').nullable()
})

export const personalizationRulesSchema = array().of(personalizationRuleSchema)
